/** R0c · the move's words (the banner; lib/platformFreeze.ts reads the flag). */
export const FREEZE_WORDS = 'Tenean is moving to its new home. Saving is paused for a short while; everything you saved before is safe.';
